import React from 'react';
import MutateTaskSingleVoyageModal from "@containers/singleVoyage/tasks/mutateTask/MutateTaskModalSingleVoyage";
import {TaskCreationSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
    useSaveTaskMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/tasks/hooks/useSaveTaskMutateSingleVoyage";

interface IProps {
    initial?: Partial<TaskCreationSingleVoyage>,
    mode?: 'add' | 'update'
}

const MutateTaskMutateSingleVoyageModal = ({
                                               initial,
                                               mode,
                                           }: IProps) => {

    const {
        points,
        accountId,
    } = useRootContextMutateSingleVoyage()

    const {
        onSaveTask,
        isLoading,
        isFetching
    } = useSaveTaskMutateSingleVoyage({
        accountId,
    })

    return (
        <MutateTaskSingleVoyageModal
            onSave={onSaveTask}
            waypoints={points}
            initial={initial}
            voyageId={0}
            disabled={isFetching || isLoading}
            mode={mode}
            accountId={accountId}
        />
    );
};

export default MutateTaskMutateSingleVoyageModal;
